import React, { FC, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '../store';
import { showTimeoutWarning } from '../store/screensaver/actions';
import { Platform } from 'sofa-reborn-react';
import TimeoutWarning from '../components/TimeoutWarning';
import { IDexfSettings, ITranslations } from '@inter-ikea-kompis/types';
import { ApplicationUtils } from '../util/ApplicationUtils';
import { localeService } from '../services';

const TimeoutWarningContainer: FC = () => {
	const platform = useSelector<RootState, Platform>((state) => state.deviceInfo.platform);
	const timeoutWarningVisible = useSelector<RootState, boolean>(
		(state) => state.screensaver.showTimeoutWarning
	);
	const kompisSettings = useSelector<RootState, IDexfSettings | null>(
		(state) => state.settings.kompisSettings
	);
	const kompisTranslations = useSelector<RootState, ITranslations | null>(
		(state) => state.localization.kompisTranslations
	);
	const showIpexGalleryButton = useSelector<RootState, boolean>(
		(state) => state.application.showIpexGalleryButton
	);
	const [time, setTime] = useState(90);

	const dispatch = useDispatch<AppDispatch>();

	const isProduction = ApplicationUtils.isProduction();

	const onClose = (): void => {
		dispatch(showTimeoutWarning({ show: false, sendEvent: true }));
	};

	const onBackToGallery = (): void => {
		dispatch(showTimeoutWarning({ show: false, sendEvent: false }));
		if (showIpexGalleryButton) {
			window.location.href = isProduction
				? (localeService.getApplicationSetting('experienceGalleryBackURL') as string)
				: 'https://www.cte.ikeadt.com/addon-app/gallery/latest/';
		}
	};

	const onTimeChange = (e: CustomEvent): void => {
		if (timeoutWarningVisible) {
			setTime(e.detail.time);
		}
	};

	useEffect(() => {
		if (timeoutWarningVisible) {
			setTime(90);
		}
	}, [timeoutWarningVisible]);

	return (
		<TimeoutWarning
			platform={platform}
			kompisSettings={kompisSettings}
			kompisTranslations={kompisTranslations}
			startTime={90}
			time={time}
			timeoutWarningVisible={timeoutWarningVisible}
			showIpexGalleryButton={showIpexGalleryButton}
			onClose={onClose}
			onSessionClick={onBackToGallery}
			onTimeEnd={onBackToGallery}
			onTimeChange={onTimeChange}
		></TimeoutWarning>
	);
};
export default TimeoutWarningContainer;
